module.exports = __webpack_public_path__ + "img/solucasa.2e52000d.png";